(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin-tools', {
            parent: 'entity',
            url: '/admin-tools',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.admin-tools.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/admin-tools/admin-tools.html',
                    controller: 'AdminToolsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
